<template>
  <div class="preiod-nav">
    <div class="itemList">
      <div class='item' :class="active === item.value?'item-active':''" v-for="(item,index) in list" :key='item.value'
        @click.stop="itemClick(item)">
        <span v-if="!item.render">{{item.label}}</span>
        <div v-else>
          <Expand :row="item" :index="index" :render="item.render"></Expand>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Expand from '@frame/components/expand'
export default {
  name: 'preiod-nav',
  components: {
    Expand,
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    active: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {

    }
  },
  methods: {
    itemClick (item) {
      this.$emit('navClick', item)
    }
  },
}
</script>
<style lang="scss" scoped>
.preiod-nav {
  width: 100%;
  padding-left: 30px;
  height: 34px;
  line-height: 30px;
  border-bottom: 1px solid #666;
  color: #999999;
  .itemList {
    height: 100%;
    display: flex;
    .item {
      width: 54px;
      text-align: center;
      cursor: pointer;
    }
    .item-active {
      position: relative;
      color: #1989fa;
      &::after {
        content: '';
        position: absolute;
        width: 50px;
        height: 2px;
        background: #1989fa;
        left: 5%;
        bottom: 0;
      }
    }
  }
}
</style>
